import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 「数据更新于」：按 UTC 解析后转仓本地时区，只出时分秒。
 * 指标条那一格宽度放不下带日期的写法，会压到指标文案上。
 * 缺时区返回空串由调用方降级，口径同 `taskTextComposer` 的 formatLocalTime。
 */
export const formatCalculatedAtTime = (value: string, timeZone?: string | null): string => {
  if (!timeZone) {
    return '';
  }
  const parsed = dayjs.utc(value);
  return parsed.isValid() ? parsed.tz(timeZone).format('HH:mm:ss') : '';
};
